module.exports = __webpack_public_path__ + "static/img/COVER-6.fdf6669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-6.png
// module id = GoJJ
// module chunks = 31